var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDiscoverCurrentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Dashboard-3--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dashboard 3 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard-3--app-application-dashboard-home-layout-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M1 0C0.447715 0 0 0.447715 0 1v6c0 0.55229 0.447715 1 1 1h4c0.55229 0 1 -0.44771 1 -1V1c0 -0.552285 -0.44771 -1 -1 -1H1Zm7 1c0 -0.552285 0.44771 -1 1 -1h4c0.5523 0 1 0.447715 1 1v2.01c0 0.55228 -0.4477 1 -1 1H9c-0.55229 0 -1 -0.44772 -1 -1V1Zm0 6c0 -0.55228 0.44771 -1 1 -1h4c0.5523 0 1 0.44772 1 1v6c0 0.5523 -0.4477 1 -1 1H9c-0.55228 0 -1 -0.4477 -1 -1V7Zm-8 3.99c0 -0.5523 0.447715 -1.00001 1 -1.00001h4c0.55229 0 1 0.44771 1 1.00001V13c0 0.5523 -0.44771 1 -1 1H1c-0.552285 0 -1 -0.4477 -1 -1v-2.01Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDiscoverCurrentWhite);
export default __webpack_public_path__ + "static/media/menu-discover-current-white.05503793a5b34944ed5988fd5320a052.svg";
export { ForwardRef as ReactComponent };